import React, { useState } from 'react'
import './AddMemberPage.css'
import { Center, Box, IconButton, Button } from '@chakra-ui/react'
import CloseIcon from '@material-ui/icons/Close'
import { useHistory, Redirect } from 'react-router-dom'

function SubHeader() {
  let history = useHistory()

  return (
    <div className="main-page">
      <Box style={{ width: '100%', height: '7%', backgroundColor: '#fff', marginTop: '2px' }}>
        <Box>
          <Button
            onClick={() => history.push('/members')}
            className="back_to_m"
            leftIcon={<CloseIcon style={{ height: '18px' }} />}
          >
            Cancel{' '}
          </Button>
        </Box>
      </Box>
    </div>
  )
}

export default SubHeader
